import { Typography, Tooltip, CSSObject } from '@mui/material';
import { CampaignChannels } from 'domains/campaigns/types';
import { channelIcons } from 'domains/campaigns/pages/CurationsPage/utils';

export type Props = {
    contentType?: CampaignChannels;
    isActive: boolean;
    onClick: () => void;
};

const labelStyles: CSSObject = {
    color: '#ffffff',
    fontSize: '1rem',
    position: 'relative',
    top: '-0.094rem',
};

const ButtonContentPreview = ({ contentType = CampaignChannels.EMAIL, isActive, onClick }: Props) => {
    const iconStyles = {
        color: isActive ? 'secondary.main' : 'primary.main',
        '&:hover': {
            color: 'secondary.main',
            cursor: 'pointer',
        },
    };

    // Determine which icon to use based on contentType
    const ContentIcon = channelIcons[contentType];

    return (
        <Tooltip
            title={
                <Typography variant="body1" sx={labelStyles}>
                    Preview content
                </Typography>
            }
            placement="top"
        >
            <ContentIcon aria-label="preview content" sx={iconStyles} onClick={onClick} />
        </Tooltip>
    );
};

export default ButtonContentPreview;
